import * as React from 'react'

import type Employee from 'modules/employees/store/models/Employee'

interface EmployeeContextProps {
  employee?: Employee
}

const EmployeeContext = React.createContext<EmployeeContextProps>({})

export const useEmployeeContext = () => React.useContext(EmployeeContext)
